firebird.factory('videoStatsTestService', [
    '$timeout',
    '$window',
    'videoGlobalService',
    function ($timeout, $window, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // Following functions are used for automation tests to gather the state of the module.
            // TODO: if there is any change in the format of the data returned, update the automation tests too.

            // synchronous API for getting media state.

            // console.log(angular.element('#videoroom').scope().videoroom.getMediaState());

            // {
            //     "connection": true,        // indicates websocket connection to Janus server
            //     "sipCall": {               // SIP plugin for voice+video publish
            //         "state": "accepted",   // idle, registering, registered, register-failed, calling,
            //                                // accepted, reconnecting, disconnected, terminating, terminated, closed
            //         "webrtc": true,        // (optional) whether peerconnection is up?
            //         "ice": "connected",    // (optional) ice connection state: connected or disconnected
            //         "media": true,         // (optional) whether media is received by server?
            //         "stream": true,        // (optional) whether media stream is created?
            //         "muted": true,         // whether audio publish is muted?
            //         "attached": false,     // (optional) whether video is being forwarded from videoroom to SIP plugin to FreeSwitch?
            //         "speaker": "default",  // (optional) speaker device
            //         "microphone": "586...6f5" // (optional) microphone device ID
            //     },
            //     "sipCallForScreen": {      // (optional) SIP plugin for screen share publish
            //         "state": "accepted",   // values similar to sipCall.state
            //         "webrtc": true,        // (optional) whether peerconnection is up?
            //         "ice": "connected",    // (optional) ice connection state
            //         "media": false,        // (optional) whether media is received by server?
            //         "attached": false      // (optional) whether video is being forwarded from videoroom to SIP plugin to FreeSwitch?
            //     },
            //     "videoPublish": {          // Videoroom plugin for video publish
            //         "state": "started",    // idle, starting, joining, joined, started, stopped, closed
            //         "webrtc": true,        // (optional) whether peerconnection is up?
            //         "ice": "connected",    // (optional) ice connection state
            //         "media": true,         // (optional) whether media is received by server?
            //         "stream": true,        // (optional) whether media stream is created and video displayed?
            //         "muted": false,        // whether video publish is muted?
            //         "camera": "4da...612"  // (optional) camera device ID
            //     },
            //     "screenPublish": {         // (optional) Videoroom publish for screen publish
            //         "state": "started",    // idle, starting, joined, started, stopped
            //         "webrtc": true,        // (optional) whether peerconnection is up?
            //         "ice": "connected",    // (optional) ice connection state
            //         "media": true,         // (optional) whether media is received by server?
            //         "stream": true         // (optional) whether media stream is created?
            //     },
            //     "videoPlay/1454306": {     // (optional) Videoroom play for video or screen, one per video
            //         "state": "started",    // idle, starting, attached, answering, started, closed
            //         "webrtc": true,        // (optional) whether peerconnection is up?
            //         "ice": "connected",    // (optional) ice connection state
            //         "stream": true,        // (optional) whether remote media stream is received and video displayed?
            //         "screen": false        // (optional) whether this is a screen share video?
            //     }
            // }

            // Asynchronous API for getting media quality, will take approximately 1.1 seconds.

            // angular.element('#videoroom').scope().videoroom.getMediaQuality(function(value) { console.log(value); });

            // {
            //     // All the attributes are optional.
            //     // These attributes are instantaneous values: bitrateDesired, frameWidth, frameHeight, jitter, simulcastFlag, simulcast, fractionLost
            //     // These attributes are calculated for last 1second: bitrate, packetsLost, jitterBufferDelay, frameRate, qpSum.
            //     // These attributes are aggregate so far in the call: firCount, pluCount, nackCount

            //     // Note that the frameRate, frameWidth and frameHeight are actual values in encoded stream, instead of
            //     // say camera captured attributes. This may be lower than camera captured attributes depending on network
            //     // condition.

            //     "audioTx": { // for audio send stream
            //         "bitrate": 47, "fractionLost": 0, "roundTripTime": 80, "averageRoundTripTime": "78"
            //     },
            //     "audioRx": { // for audio receive stream
            //         "bitrate": 47, "packetsLost": 0, "jitter": 0, "jitterBufferDelay": 2400
            //     },
            //     "videoTx": { // for video send stream
            //         "bitrate": 948, "bitrateDesired": 1000, "frameRate": 30, "frameWidth": 1280, "frameHeight": 720,
            //         "simulcastFlag": false, "qpSum": 40, "firCount": 2, "pliCount": 3, "nackCount": 0,
            //         "fractionLost": 0, "roundTripTime": 80, "averageRoundTripTime": "78",
            //         "qualityLimitationReason": "none"
            //     },
            //     "screenTx": { // for screen send stream
            //         "bitrate": 42, "bitrateDesired": 1000, "frameRate": 4, "frameWidth": 704, "frameHeight": 520,
            //         "simulcastFlag": false, "qpSum": 15, "firCount": 2, "pliCount": 4, "nackCount": 0,
            //         "fractionLost": 0, "roundTripTime": 80, "averageRoundTripTime": "78",
            //         "qualityLimitationReason": "none"
            //     },
            //     "videoRx/1454306": { // for each video receive stream or remote video box including screen share video.
            //         "bitrate": 934, "frameRate": 30, "frameWidth": 1280, "frameHeight": 720,
            //         "simulcast": null, "packetsLost": 0, "firCount": 0, "pliCount": 0, "nackCount": 0
            //     }
            // }

            self.getMediaState = getMediaState;
            self.getMediaQuality = getMediaQuality;
            self.getMediaStatistics = getMediaStatistics;
        }

        function getMediaState() {
            var value = {
                connection: self.getJanusConnectionState() == 'connected'
            };

            //determine stream/mute state
            var audioTrack = (self.mystream1 && self.mystream1.getAudioTracks()[0]) || null;
            var videoTrack = (self.mystream && self.mystream.getVideoTracks()[0]) || null;

            if (self.sipcall && self.sipcall.state) {
                value.sipCall = {
                    state: self.sipcall.state.call,
                    webrtc: !!self.sipcall.state.webrtc,
                    ice: self.sipcall.state.ice,
                    media: !!self.sipcall.state.media,
                    stream: {
                        exists: !!self.mystream1,
                        active: !!(self.mystream1 && self.mystream1.active),
                        track: audioTrack
                            ? {
                                  state: audioTrack.readyState,
                                  muted: !audioTrack.enabled
                              }
                            : null
                    },
                    attached: !!self.sipcall.state.attached,
                    speaker: $window.$('#videoroom-sipaudio')[0].sinkId,
                    microphone: self.selectedAudioInput
                };
            } else {
                value.sipcall = {
                    state: 'idle',
                    muted: true
                };
            }
            if (self.screensipcall && self.screensipcall.state) {
                value.sipCallForScreen = {
                    state: self.screensipcall.state.call,
                    webrtc: !!self.screensipcall.state.webrtc,
                    ice: self.screensipcall.state.ice,
                    media: !!self.screensipcall.state.media,
                    attached: !!self.screensipcall.state.attached
                };
            }
            if (self.videoroom && self.videoroom.state) {
                value.videoPublish = {
                    state: self.videoroom.state.call,
                    webrtc: !!self.videoroom.state.webrtc,
                    ice: self.videoroom.state.ice,
                    media: !!self.videoroom.state.media,
                    stream: {
                        exists: !!self.mystream,
                        active: !!(self.mystream && self.mystream.active),
                        track: videoTrack
                            ? {
                                  state: videoTrack.readyState,
                                  muted: !videoTrack.enabled
                              }
                            : null
                    },
                    camera: self.selectedVideoInput
                };
            } else {
                value.videoPublish = {
                    state: 'idle',
                    muted: true
                };
            }
            if (self.screenshare && self.screenshare.state) {
                value.screenPublish = {
                    state: self.screenshare.state.call,
                    webrtc: !!self.screenshare.state.webrtc,
                    ice: self.screenshare.state.ice,
                    media: !!self.screenshare.state.media,
                    stream: !!self.screenstream
                };
            } else {
                value.screenPublish = {
                    state: 'idle'
                };
            }
            for (var id in self.feeds) {
                var feed = self.feeds[id];
                var value0 = {};
                if (typeof feed === 'object' && feed.state) {
                    value0 = {
                        state: feed.state.call,
                        webrtc: !!feed.state.webrtc,
                        ice: feed.state.ice,
                        stream: !!feed.state.video,
                        screen: !!feed.isScreen
                    };
                    if (feed.state.playing !== undefined) {
                        value0.playing = feed.state.playing;
                    }
                    if (feed.state.frozen !== undefined) {
                        value0.frozen = feed.state.frozen;
                    }
                } else {
                    value0 = {
                        state: 'idle'
                    };
                }
                value['videoPlay/' + id] = value0;
            }

            return value;
        }

        function getMediaQuality(callback) {
            if (callback === undefined) {
                throw Error('must supply callback function');
            }

            var statsLast = {};

            self.calculateMediaQualityMetrics(statsLast);
            $timeout(function () {
                self.calculateMediaQualityMetrics(statsLast, function (value) {
                    if (callback) {
                        callback(value);
                    }
                });
            }, 1000);
        }

        function getMediaStatistics(callback) {
            if (callback === undefined) {
                throw Error('must supply callback function');
            }
            self.calculateMediaQualityMetrics(undefined, function (value) {
                if (callback) {
                    value.conferenceUserID = '' + self.myroom;
                    value.attendeeId = '' + self.attendantId;
                    callback(value);
                }
            });
        }
    }
]);
